export enum directionEnum {
	previous = 'previous',
	next = 'next'
}